import {reaction} from "../config/config";

export const convertReactionUsersToReactionData = (reactionUsers = null) => {
	let reactionData = [];

	if (!reactionUsers) return reactionData;

	if (typeof reactionUsers !== "object") {
		reactionUsers = Object.values(reactionUsers);
	}

	reactionUsers.map(reactionUser => {
		reactionData.push({
			node: reaction(reactionUser.reaction_id).node,
			label: reaction(reactionUser.reaction_id).label,
			by: reactionUser.username
		})
	})

	return reactionData;
}